// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"CrematoryModal_checkboxContainer__2qEP6","deleteButton":"CrematoryModal_deleteButton__bMvoc","loaderContainer":"CrematoryModal_loaderContainer__puzAl"};